export default __webpack_public_path__ + "static/media/correctArrow.0770813e.svg";